import { Injectable } from '@angular/core';
import {AppSettings} from "../../proyect.conf";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {paginador, RotativoUC} from "../_models/rotativo-uc";
import {ExcelAvance} from "../_models/excel-avance";
import {LanzadoIntegracionIndividual} from "../_models/lanzado-integracion-individual";

@Injectable({
  providedIn: 'root'
})
export class SolicitudesUCErroresIntegracionesService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/solicitudesUCErroresIntegraciones';

  constructor(private httpClient: HttpClient) { }

  listado(busqueda: any) {
    return this.httpClient.post(this.rutServicio + '/sucErrorActualizarCore/todos', busqueda).pipe(map((res) => res as paginador));
  }

  lanzarTodos(idUsuario: string) {
    return this.httpClient.get(this.rutServicio + '/sucErrorActualizarCore/usuario/' + idUsuario).pipe(map((res) => res as ExcelAvance));
  }

  lanzarIndividual(idusuario: string, idSolicitudUc: string) {
    return this.httpClient.get(this.rutServicio + '/sucErrorActualizarCore/suc/' + idSolicitudUc + '/usuario/' + idusuario).pipe(map((res) => res as LanzadoIntegracionIndividual));
  }

  eliminar(idusuario: string, idSolicitudUc: string) {
    return this.httpClient.get(this.rutServicio + '/eliminar/sucErrorActualizarCore/suc/' + idSolicitudUc + '/usuario/' + idusuario).pipe(map((res) => res as LanzadoIntegracionIndividual));
  }
}
